import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Presentazione from "@/components/Presentazione";
import Spazi from "@/components/Spazi";
import Servizi from "@/components/Servizi";
import DiconoDiNoi from "@/components/DiconoDiNoi";
import Gallery from "@/components/Gallery";
import Eventi from "@/components/Eventi";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);

    window.scrollToSection = (id) => {
      lenis.scrollTo(id, { offset: -72, duration: 1.4 });
    };

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.scrollToSection;
    };
  }, []);

  return (
    <div className="App bg-midnight text-linen antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Presentazione />
        <Spazi />
        <Servizi />
        <DiconoDiNoi />
        <Gallery />
        <Eventi />
        <Contatti />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
